export default {
    methods: {
        scrollToTopErrorMessage () {
            this.$nextTick(() => {
                const errorElement = document.querySelector(
                    '.v-messages .v-messages__message, .v-message .v-messages__message'
                );
                if (errorElement) {
                    this.$vuetify.goTo(errorElement, {
                        easing: 'easeInQuad',
                        offset: window.innerHeight / 2
                    });
                }
            });
        }
    }
};
